module.exports = {
  stickyHeader: 19,
  header: 20,
  dropdown: 50,
  modal: 100,
}
